module.exports = __webpack_public_path__ + "static/media/merck_privacy_policy_USA.f5d99900.pdf";